import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../classes/api-response';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BoxEvent } from "../model/box-event";
import { Constants } from "../utils/constants";

@Injectable({
  providedIn: 'root'
})
export class BoxEventsService {

  private readonly entities = Constants.entities;
  private readonly crtlPathFragment = this.entities.boxEventsController;
  private readonly crtlFullPath = `${environment.apiUrl}/${this.crtlPathFragment}`;

  constructor(private http: HttpClient) {
  }

  public getAllBoxEvents(boxId?: number): Observable<BoxEvent[]> {
    return this.http
      .get<ApiResponse>(`${environment.apiUrl}/${this.entities.boxes}/${boxId}/${this.crtlPathFragment}`)
      .pipe(map(value => value.data as BoxEvent[]));
  }

  public getAllBoxEventsByContract(contractId?: number, boxId?: number): Observable<BoxEvent[]> {
    return this.http
      .get<ApiResponse>(`${environment.apiUrl}/${this.entities.contracts}/${contractId}/${this.entities.boxes}/${boxId}/${this.crtlPathFragment}`)
      .pipe(map(value => value.data as BoxEvent[]));
  }


  public getBoxEvent(boxEventId: number): Observable<BoxEvent> {
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}/${boxEventId}`)
      .pipe(map(value => value.data as BoxEvent));
  }


}
